module.exports = {"513425001":"城北街道","513425002":"城南街道","513425101":"鹿厂镇","513425102":"黎溪镇","513425103":"通安镇","513425104":"太平镇","513425105":"益门镇","513425106":"绿水镇","513425107":"新发镇","513425108":"云甸镇","513425109":"关河镇","513425110":"富乐镇","513425111":"彰冠镇","513425112":"木古镇","513425113":"六华镇","513425114":"小黑箐镇","513425202":"内东乡","513425204":"外北乡","513425206":"爱民乡","513425217":"黎洪乡","513425219":"树堡乡","513425221":"新安傣族乡","513425223":"竹箐乡","513425225":"杨家坝乡","513425234":"槽元乡","513425238":"白果湾乡","513425239":"下村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513425.json
// module id = 2566
// module chunks = 0